<app-atom-model-counter
	[label]="'counter-label-formation' | translate"
	[customClass]="'counter-formation'"
	[loading]="loading"
	[count]="count"
	[iconTpl]="iconTpl"
	[linkFullList]="['/formation/list']"
></app-atom-model-counter>

<ng-template #iconTpl>
	<i nz-icon nzType="audit" nzTheme="outline"></i>
</ng-template>
